// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c8787181","453":"9e812b32","732":"7cd81701","977":"28cead29"}[chunkId] + ".chunk.js";
};